import { createIcon } from '@chakra-ui/icons';

export const AdobexdLogo = createIcon({
  displayName: 'AdobexdLogo',
  viewBox: '0 0 24 24',
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M4.042 0h12.916A3.539 3.539 0 0120.5 3.542v12.416a3.539 3.539 0 01-3.542 3.542H4.042A3.539 3.539 0 01.5 15.958V3.542A3.539 3.539 0 014.042 0z"
        fill="#470137"
      />
      <path
        d="M11.017 5.124l-2.5 4.125 2.666 4.375a.143.143 0 01.017.1c-.008.034-.042.009-.092.017H9.2c-.133 0-.225-.008-.283-.092-.175-.35-.359-.691-.534-1.041a33.608 33.608 0 00-.566-1.05c-.2-.359-.4-.717-.6-1.084H7.2c-.175.359-.367.717-.558 1.075-.192.359-.384.717-.567 1.067-.192.35-.383.708-.575 1.05-.033.083-.1.092-.192.092H3.475c-.033 0-.058.016-.058-.025a.116.116 0 01.016-.092l2.592-4.25L3.5 5.116c-.025-.033-.033-.067-.017-.083.017-.025.05-.034.084-.034h1.891c.042 0 .084.009.117.017a.236.236 0 01.083.075c.159.358.342.717.534 1.075.2.358.391.708.6 1.058.2.35.383.7.558 1.059h.017c.175-.367.358-.725.541-1.075.184-.35.375-.7.567-1.05.192-.35.375-.709.558-1.05.009-.034.025-.067.05-.084a.159.159 0 01.109-.016h1.758a.077.077 0 01.091.058c.009.008-.008.042-.024.058zM14.866 13.917a4.144 4.144 0 01-1.791-.375 2.906 2.906 0 01-1.259-1.134c-.308-.508-.458-1.141-.458-1.9a3.423 3.423 0 011.783-3.05c.584-.325 1.284-.483 2.109-.483.041 0 .1 0 .175.008.075.009.158.009.258.017V4.367c0-.059.025-.092.083-.092h1.692c.042-.008.075.025.083.058v7.95c0 .15.009.317.017.5.017.175.025.342.033.484 0 .058-.025.108-.083.133a6.365 6.365 0 01-1.358.4 7.35 7.35 0 01-1.284.117zm.817-1.667V8.583c-.075-.016-.15-.033-.225-.041-.092-.009-.183-.017-.275-.017-.325 0-.65.067-.942.217-.283.141-.525.35-.708.616-.183.267-.275.625-.275 1.059-.008.291.042.583.142.858.083.225.208.425.375.592.158.15.35.266.566.333.225.075.459.108.692.108.125 0 .242-.008.35-.016a.73.73 0 00.3-.042z"
        fill="#FF61F6"
      />
    </g>
  ),
});

export const AtlassianLogo = createIcon({
  displayName: 'AtlassianLogo',
  viewBox: '0 0 24 24',
  path: (
    <g>
      <path
        d="M6.427 9.239a.57.57 0 00-.798-.108.591.591 0 00-.167.209l-4.9 9.803a.586.586 0 00.524.847h6.827a.562.562 0 00.523-.324c1.474-3.043.58-7.67-2.01-10.427z"
        fill="#2684FF"
      />
      <path
        d="M10.028.318a12.932 12.932 0 00-.755 12.765l3.292 6.583a.586.586 0 00.523.324h6.826a.583.583 0 00.586-.585c0-.091-.02-.18-.06-.262L11.024.315a.552.552 0 00-.997 0v.003z"
        fill="#2684FF"
      />
    </g>
  ),
});

export const BikeIcon = createIcon({
  displayName: 'BikeIcon',
  viewBox: '0 0 18 18',
  path: (
    <path
      d="M13.635 7.5L12.36 3.99C12.1425 3.3975 11.58 3 10.95 3H9V4.5H10.95L12.045 7.5H8.4375L8.1675 6.75H9V5.25H5.25V6.75H6.5625L7.9275 10.5H7.425C7.095 8.8275 5.6925 7.59 3.9375 7.5075C1.8375 7.4025 0 9.15 0 11.25C0 13.35 1.65 15 3.75 15C5.595 15 7.0875 13.7325 7.425 12H10.575C10.905 13.6725 12.3075 14.91 14.0625 14.9925C16.1625 15.09 18 13.35 18 11.2425C18 9.1425 16.35 7.4925 14.25 7.4925H13.635V7.5ZM5.865 12C5.565 12.8775 4.7475 13.5 3.75 13.5C2.49 13.5 1.5 12.51 1.5 11.25C1.5 9.99 2.49 9 3.75 9C4.7475 9 5.565 9.6225 5.865 10.5H3.75V12H5.865ZM10.575 10.5H9.525L8.9775 9H11.25C10.92 9.435 10.68 9.9375 10.575 10.5ZM14.25 13.5C12.99 13.5 12 12.51 12 11.25C12 10.5525 12.3075 9.9525 12.7875 9.54L13.5075 11.52L14.9175 11.01L14.19 9.0075C14.2125 9.0075 14.235 9 14.2575 9C15.5175 9 16.5075 9.99 16.5075 11.25C16.5075 12.51 15.51 13.5 14.25 13.5Z"
    />
  ),
});

export const CartIcon = createIcon({
  displayName: 'CartIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      d="M7.984 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM17.828 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM20.324 5.558a1.051 1.051 0 00-.815-.386H6.134l-.27-1.528a.703.703 0 00-.692-.581H2.359a.703.703 0 000 1.406h2.223L6.59 15.841a.703.703 0 00.692.581h11.25a.703.703 0 100-1.406H7.871l-.248-1.406h10.62a1.057 1.057 0 001.035-.848l1.266-6.328a1.055 1.055 0 00-.22-.876z"
    />
  ),
});

export const ClockIcon = createIcon({
  displayName: 'ClockIcon',
  viewBox: '0 0 24 24',
  path: (
    <g>
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g>
          <g>
            <path
              fill="currentColor"
              d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z"
            />
          </g>
        </g>
      </g>
    </g>
  ),
});
export const CreativeTimLogo = createIcon({
  displayName: 'CreativeTimLogo',
  viewBox: '0 0 100 100',
  path: (
    <g
      xmlns="http://www.w3.org/2000/svg"
      width="50px"
      height="50px"
      version="1.1">
      <g
        id="logo-creative-tim-black"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="icon"
          transform="translate(15.000000, 19.000000)"
          fill="currentColor"
          fillRule="nonzero">
          <path
            d="M66.4346744,1.49018376e-13 L3.56968951,1.49018376e-13 C1.59820443,1.49018376e-13 -2.98036753e-13,1.59820443 -2.98036753e-13,3.56968951 L-2.98036753e-13,33.5035241 C-2.98036753e-13,35.4750091 1.59820443,37.0732136 3.56968951,37.0732136 L16.4677598,37.0732136 L16.4677598,66.4346744 C16.4666001,67.3810129 16.8417189,68.288989 17.5104719,68.9585615 C18.1792249,69.628134 19.0867408,70.0043639 20.03308,70.0043639 L49.9669146,70.0043639 C51.9383997,70.0043639 53.5366041,68.4061595 53.5366041,66.4346744 L53.5366041,37.0863214 L66.4346744,37.0863214 C67.3810136,37.0863221 68.2885296,36.7100915 68.9572826,36.0405189 C69.6260355,35.3709464 70.0011544,34.4629704 70,33.5166319 L70,3.56968951 C70.0011544,2.62335099 69.6260355,1.71537495 68.9572826,1.04580242 C68.2885296,0.37622988 67.3810136,1.49018376e-13 66.4346744,1.49018376e-13 Z M4.13769396,4.14206323 L32.9311503,4.14206323 L32.9311503,32.9355196 L4.13769396,32.9355196 L4.13769396,4.14206323 Z M49.3989102,65.86667 L20.6054538,65.86667 L20.6054538,37.0863214 L49.3989102,37.0863214 L49.3989102,65.86667 Z M65.8623007,32.9355196 L37.0688443,32.9355196 L37.0688443,4.14206323 L65.8623007,4.14206323 L65.8623007,32.9355196 Z"
            id="Shape"
          />
          <path
            d="M23.6988934,23.3056595 C24.5142794,24.0708897 25.7898859,24.0506562 26.5805917,23.2599503 C27.3712976,22.4692445 27.3915311,21.193638 26.6263009,20.378252 L20.015603,13.767554 C19.2050095,12.9645312 17.8987889,12.9645312 17.0881954,13.767554 L10.4600204,20.378252 C9.90907005,20.8953125 9.68342943,21.6713831 9.87125954,22.4032422 C10.0590897,23.1351013 10.6305787,23.7065903 11.3624377,23.8944204 C12.0942968,24.0822505 12.8703675,23.8566099 13.387428,23.3056595 L18.5344222,18.1586654 L23.6988934,23.3056595 Z"
            id="Path"
          />
          <path
            d="M46.3185783,23.3056595 L51.4655725,18.1586654 L56.6125667,23.3056595 C57.4279526,24.0708897 58.7035592,24.0506562 59.494265,23.2599503 C60.2849709,22.4692445 60.3052044,21.193638 59.5399742,20.378252 L52.9292763,13.767554 C52.1186828,12.9645312 50.8124622,12.9645312 50.0018687,13.767554 L43.3911708,20.378252 C42.6259406,21.193638 42.6461741,22.4692445 43.43688,23.2599503 C44.2275858,24.0506562 45.5031924,24.0708897 46.3185783,23.3056595 L46.3185783,23.3056595 Z"
            id="Path"
          />
          <path
            d="M29.8508185,46.6987044 C29.0342976,45.9346441 27.7586832,45.9567597 26.9691385,46.7486649 C26.1795937,47.54057 26.1612859,48.8162446 26.9277802,49.6304812 L33.5384782,56.2368099 C33.9262423,56.6258256 34.452915,56.8444779 35.002182,56.8444779 C35.5514489,56.8444779 36.0781217,56.6258256 36.4658857,56.2368099 L43.0765837,49.6304812 C43.6002952,49.1075502 43.8052442,48.3449453 43.6142284,47.6299323 C43.4232126,46.9149194 42.8652519,46.3561259 42.1505246,46.1640439 C41.4357974,45.971962 40.6728876,46.1757734 40.1491761,46.6987044 L35.002182,51.8500678 L29.8508185,46.6987044 Z"
            id="Path"
          />
        </g>
      </g>
    </g>
  ),

  //   <chakra.svg
  //   height="50px"
  //   width="50px"
  //   viewBox="0 0 100 100"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  //   color={fill}
  //   {...props}
  // >
  // </chakra.svg>
});

export const CreditIcon = createIcon({
  displayName: 'CreditIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      d="M1.406 17.023a2.461 2.461 0 002.461 2.46h14.766a2.461 2.461 0 002.46-2.46v-6.768H1.407v6.768zm2.9-3.34a1.318 1.318 0 011.319-1.318h2.11a1.318 1.318 0 011.318 1.318v.879a1.318 1.318 0 01-1.319 1.318H5.625a1.318 1.318 0 01-1.318-1.318v-.879zM18.633 4.014H3.867a2.46 2.46 0 00-2.46 2.461v1.143h19.687V6.475a2.46 2.46 0 00-2.461-2.46z"
    />
  ),
});

export const DashboardLogo = createIcon({
  displayName: 'DashboardLogo',
  viewBox: '0 0 1000 257',
  path: (
    <g width="998" height="257" viewBox="0 0 998 257" fill="none">
      <g clipPath="url(#clip0)">
        <path
          d="M388.5 115.302C406.112 115.302 413.966 126.726 416.584 136.96L441.336 127.916C436.576 109.352 419.44 89.836 388.262 89.836C354.942 89.836 329 115.54 329 151.24C329 186.464 354.942 212.882 388.976 212.882C419.44 212.882 436.814 193.128 442.288 175.04L418.012 166.234C415.394 175.04 407.064 187.654 388.976 187.654C371.602 187.654 356.608 174.564 356.608 151.24C356.608 127.916 371.602 115.302 388.5 115.302Z"
          fill="currentColor"
        />
        <path
          d="M484.894 141.244C485.37 126.488 493.7 115.064 508.932 115.064C526.306 115.064 532.732 126.488 532.732 140.768V209.312H560.34V136.008C560.34 110.542 546.536 90.074 517.976 90.074C505.838 90.074 492.748 94.358 484.894 104.592V37H457.286V209.312H484.894V141.244Z"
          fill="currentColor"
        />
        <path
          d="M577.29 177.896C577.29 196.222 592.284 212.882 616.56 212.882C635.362 212.882 646.786 203.362 652.26 194.556C652.26 203.838 653.212 208.598 653.45 209.312H679.154C678.916 208.122 677.726 201.22 677.726 190.748V133.152C677.726 110.066 664.16 89.836 628.46 89.836C599.9 89.836 581.812 107.686 579.67 127.678L604.898 133.39C606.088 121.728 614.18 112.446 628.698 112.446C643.93 112.446 650.594 120.3 650.594 130.058C650.594 134.104 648.69 137.436 642.026 138.388L612.276 142.91C592.522 145.766 577.29 157.19 577.29 177.896ZM621.796 191.224C610.848 191.224 604.898 184.084 604.898 176.23C604.898 166.71 611.8 161.95 620.368 160.522L650.594 156V161.236C650.594 183.846 637.266 191.224 621.796 191.224Z"
          fill="currentColor"
        />
        <path
          d="M810.108 93.406H773.456L728.95 140.292V37H701.58V209.312H728.95V176.944L743.23 161.95L777.264 209.312H811.06L762.508 142.434L810.108 93.406Z"
          fill="currentColor"
        />
        <path
          d="M889.349 92.692C888.159 92.454 885.303 91.978 881.971 91.978C866.739 91.978 853.887 99.356 848.413 111.97V93.406H821.519V209.312H849.127V154.096C849.127 132.438 858.885 120.062 880.305 120.062C883.161 120.062 886.255 120.3 889.349 120.776V92.692Z"
          fill="currentColor"
        />
        <path
          d="M895.968 177.896C895.968 196.222 910.962 212.882 935.238 212.882C954.04 212.882 965.464 203.362 970.938 194.556C970.938 203.838 971.89 208.598 972.128 209.312H997.832C997.594 208.122 996.404 201.22 996.404 190.748V133.152C996.404 110.066 982.838 89.836 947.138 89.836C918.578 89.836 900.49 107.686 898.348 127.678L923.576 133.39C924.766 121.728 932.858 112.446 947.376 112.446C962.608 112.446 969.272 120.3 969.272 130.058C969.272 134.104 967.368 137.436 960.704 138.388L930.954 142.91C911.2 145.766 895.968 157.19 895.968 177.896ZM940.474 191.224C929.526 191.224 923.576 184.084 923.576 176.23C923.576 166.71 930.478 161.95 939.046 160.522L969.272 156V161.236C969.272 183.846 955.944 191.224 940.474 191.224Z"
          fill="currentColor"
        />
        <rect width="257" height="257" rx="128.5" fill="#4FD1C5" />
        <path
          d="M69.5584 133.985L157.15 46.9959C158.787 45.3708 161.42 47.3484 160.315 49.3729L127.714 109.125C126.987 110.457 127.951 112.083 129.47 112.083H185.809C187.624 112.083 188.501 114.306 187.174 115.545L88.4456 207.687C86.6753 209.339 84.0405 207.011 85.4617 205.051L132.197 140.578C133.156 139.256 132.211 137.404 130.578 137.404H70.9677C69.1826 137.404 68.2917 135.243 69.5584 133.985Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="128.5"
          y1="0"
          x2="128.5"
          y2="257"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#7BCBD4" />
          <stop offset="1" stopColor="#29C6B7" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="997.832" height="257" fill="white" />
        </clipPath>
      </defs>
    </g>
  ),
});

export const DashboardLogoWhite = createIcon({
  displayName: 'DashboardLogo',
  viewBox: '0 0 163.5 42',
  path: (
    <g fill="none">
      <path
        d="M63.452 19.292c2.877 0 4.16 1.911 4.587 3.623l4.043-1.513c-.777-3.106-3.576-6.371-8.668-6.371-5.443 0-9.68 4.3-9.68 10.274 0 5.893 4.237 10.313 9.796 10.313 4.976 0 7.813-3.305 8.707-6.331l-3.965-1.473c-.427 1.473-1.788 3.583-4.742 3.583-2.837 0-5.286-2.19-5.286-6.092 0-3.903 2.449-6.013 5.208-6.013zM79.196 23.632c.078-2.469 1.438-4.38 3.926-4.38 2.838 0 3.887 1.911 3.887 4.3v11.47h4.51V22.755c0-4.26-2.255-7.685-6.92-7.685-1.982 0-4.12.716-5.403 2.429V6.19h-4.509v28.831h4.51V23.632zM94.287 29.765c0 3.066 2.449 5.853 6.414 5.853 3.071 0 4.936-1.592 5.83-3.066 0 1.553.156 2.35.195 2.47h4.198c-.039-.2-.233-1.355-.233-3.107v-9.637c0-3.862-2.216-7.247-8.047-7.247-4.664 0-7.619 2.986-7.968 6.332l4.12.955c.194-1.951 1.516-3.504 3.887-3.504 2.488 0 3.576 1.314 3.576 2.947 0 .677-.311 1.234-1.399 1.393l-4.859.757c-3.226.478-5.714 2.39-5.714 5.854zm7.269 2.23c-1.788 0-2.76-1.195-2.76-2.509 0-1.593 1.127-2.39 2.527-2.628l4.936-.757v.876c0 3.783-2.176 5.018-4.703 5.018zM132.312 15.628h-5.986l-7.269 7.845V6.191h-4.47v28.83h4.47v-5.416l2.332-2.508 5.559 7.924h5.52l-7.93-11.19 7.774-8.203zM145.254 15.509a6.3 6.3 0 00-1.205-.12c-2.487 0-4.587 1.235-5.481 3.345v-3.106h-4.392v19.393h4.509v-9.238c0-3.624 1.594-5.695 5.092-5.695.467 0 .972.04 1.477.12v-4.7zM146.335 29.765c0 3.066 2.449 5.853 6.414 5.853 3.071 0 4.937-1.592 5.831-3.066 0 1.553.156 2.35.194 2.47h4.199c-.039-.2-.234-1.355-.234-3.107v-9.637c0-3.862-2.215-7.247-8.046-7.247-4.665 0-7.619 2.986-7.969 6.332l4.121.955c.194-1.951 1.516-3.504 3.887-3.504 2.488 0 3.576 1.314 3.576 2.947 0 .677-.311 1.234-1.399 1.393l-4.859.757c-3.227.478-5.715 2.39-5.715 5.854zm7.269 2.23c-1.788 0-2.759-1.195-2.759-2.509 0-1.593 1.127-2.39 2.526-2.628l4.937-.757v.876c0 3.783-2.177 5.018-4.704 5.018zM41.975 21.5C41.975 9.626 32.578 0 20.987 0 9.398 0 0 9.626 0 21.5S9.396 43 20.988 43c11.59 0 20.987-9.626 20.987-21.5z"
        fill="#fff"
      />
      <path
        d="M11.36 22.418L25.668 7.863c.267-.272.697.06.517.398l-5.325 9.997c-.119.223.039.495.287.495h9.202c.296 0 .44.372.223.58L14.446 34.748c-.29.277-.72-.113-.488-.44l7.633-10.788c.157-.221.003-.531-.264-.531H11.59c-.292 0-.437-.362-.23-.572z"
        fill="#3BCBBE"
      />
    </g>
  ),
});

export const DocumentIcon = createIcon({
  displayName: 'DocumentIcon',
  viewBox: '0 0 24 24',
  path: (
    <g>
      <path
        fill="currentColor"
        d="M18.809 10.344h-6.153a2.11 2.11 0 01-2.11-2.11V2.083a.176.176 0 00-.175-.176H6.328A2.812 2.812 0 003.516 4.72v14.063a2.812 2.812 0 002.812 2.812h9.844a2.812 2.812 0 002.812-2.813V10.52a.176.176 0 00-.175-.176z"
      />
      <path
        fill="currentColor"
        d="M18.423 8.789l-6.32-6.32a.088.088 0 00-.15.062v5.705a.703.703 0 00.703.703h5.705a.088.088 0 00.062-.15z"
      />
    </g>
  ),
});

export const EditIcon = createIcon({
  displayName: 'EditIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#0D0C0C"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.795 2.69266L15.8075 3.70516C16.4 4.29016 16.4 5.24266 15.8075 5.82766L5.885 15.7502H2.75V12.6152L10.55 4.80766L12.6725 2.69266C13.2575 2.10766 14.21 2.10766 14.795 2.69266ZM4.25 14.2502L5.3075 14.2952L12.6725 6.92266L11.615 5.86516L4.25 13.2302V14.2502Z"
      />
    </svg>
  ),
});

export const GlobeIcon = createIcon({
  displayName: 'GlobeIcon',
  viewBox: '0 0 24 24',
  path: (
    <g>
      <path
        stroke="currentColor"
        fill="transparent"
        d="M11.25 2.109a9.14 9.14 0 100 18.281 9.14 9.14 0 000-18.281z"
        strokeWidth=".75"
        strokeMiterlimit="10"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M11.25 2.109C8.698 2.109 6.3 6.2 6.3 11.249c0 5.048 2.4 9.14 4.951 9.14 2.552 0 4.951-4.092 4.951-9.14 0-5.048-2.399-9.14-4.95-9.14z"
        strokeWidth=".75"
        strokeMiterlimit="10"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904M17.344 17.344c-1.68-1.193-3.796-1.904-6.094-1.904-2.298 0-4.413.711-6.094 1.904"
        strokeWidth=".75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M11.25 2.109v18.28M20.39 11.249H2.11"
        strokeWidth=".75"
        strokeMiterlimit="10"
      />
    </g>
  ),
});

export const HelpIcon = createIcon({
  displayName: 'HelpIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      d="M11.25 0C5.04 0 0 5.04 0 11.25S5.04 22.5 11.25 22.5 22.5 17.46 22.5 11.25 17.46 0 11.25 0zm-.352 17.813a1.172 1.172 0 110-2.344 1.172 1.172 0 010 2.344zm1.96-5.977c-.95.637-1.08 1.222-1.08 1.758a.82.82 0 11-1.641 0c0-1.284.59-2.305 1.806-3.121 1.13-.758 1.768-1.239 1.768-2.295 0-.718-.41-1.264-1.26-1.668-.199-.095-.644-.187-1.191-.18-.687.008-1.22.172-1.63.503-.775.623-.84 1.302-.84 1.312a.821.821 0 11-1.642-.08c.007-.142.106-1.425 1.452-2.507.698-.562 1.585-.854 2.636-.866.745-.01 1.444.117 1.918.34 1.418.672 2.198 1.79 2.198 3.146 0 1.982-1.325 2.872-2.494 3.658z"
    />
  ),
});

export const HomeIcon = createIcon({
  displayName: 'HomeIcon',
  viewBox: '0 0 24 24',
  path: (
    <g>
      <path
        fill="currentColor"
        d="M11.494 4.951a.351.351 0 00-.486 0l-8.09 7.729a.352.352 0 00-.109.254v7.254a1.406 1.406 0 001.405 1.406h4.223a.703.703 0 00.704-.703v-5.976a.351.351 0 01.351-.352h3.516a.351.351 0 01.351.352v5.976a.703.703 0 00.704.703h4.22a1.407 1.407 0 001.407-1.406v-7.254a.35.35 0 00-.108-.254L11.494 4.95z"
      />
      <path
        fill="currentColor"
        d="M21.574 11.23l-3.287-3.144V3.314a.703.703 0 00-.703-.703h-2.11a.703.703 0 00-.703.703V4.72l-2.545-2.434c-.239-.24-.593-.378-.976-.378-.38 0-.734.138-.972.379L.93 11.23a.717.717 0 00-.058.983.703.703 0 001.018.046l9.119-8.713a.352.352 0 01.486 0l9.12 8.713a.703.703 0 00.992-.019c.27-.28.248-.74-.033-1.01z"
      />
    </g>
  ),
});

export const InvisionLogo = createIcon({
  displayName: 'InvisionLogo',
  viewBox: '0 0 24 24',
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M18.687 0H2.313A1.813 1.813 0 00.5 1.811v16.374C.5 19.188 1.312 20 2.313 20h16.374a1.813 1.813 0 001.813-1.813V1.812A1.813 1.813 0 0018.687 0z"
        fill="#DC395F"
      />
      <path
        d="M7.184 6.293c.665 0 1.222-.522 1.222-1.204 0-.683-.557-1.204-1.222-1.204-.665 0-1.222.521-1.222 1.204 0 .682.557 1.204 1.222 1.204zM4.65 12.739a4.134 4.134 0 00-.108.905c0 1.06.575 1.764 1.797 1.764 1.013 0 1.834-.602 2.426-1.573l-.361 1.449h2.012l1.15-4.612c.287-1.168.844-1.774 1.689-1.774.665 0 1.078.413 1.078 1.096 0 .197-.018.413-.09.646l-.593 2.12c-.09.306-.126.611-.126.899 0 1.006.593 1.742 1.833 1.742 1.06 0 1.904-.682 2.371-2.317l-.79-.305c-.395 1.095-.737 1.293-1.006 1.293-.27 0-.414-.18-.414-.538 0-.162.037-.342.09-.558l.575-2.065c.144-.485.198-.915.198-1.31 0-1.546-.934-2.352-2.066-2.352-1.06 0-2.138.956-2.677 1.962l.395-1.806H8.962L8.53 8.996h1.438l-.885 3.544c-.695 1.545-1.972 1.57-2.132 1.534-.264-.06-.432-.159-.432-.5 0-.198.036-.482.126-.823l1.348-5.346H4.579l-.431 1.591h1.419L4.65 12.74"
        fill="#fff"
      />
    </g>
  ),
});

export const JiraLogo = createIcon({
  displayName: 'JiraLogo',
  viewBox: '0 0 24 24',
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M20.26 10.42l-8.863-8.93-.86-.865-6.67 6.722L.814 10.42a.827.827 0 000 1.162l6.096 6.14 3.627 3.654 6.67-6.722.105-.104 2.947-2.964a.824.824 0 000-1.166zm-9.722 3.649L7.493 11l3.045-3.068L13.582 11l-3.044 3.068z"
        fill="#2684FF"
      />
      <path
        d="M10.537 7.932a5.184 5.184 0 01-1.502-3.637A5.185 5.185 0 0110.515.65L3.852 7.36l3.626 3.654 3.06-3.082z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M13.59 10.992l-3.053 3.076a5.186 5.186 0 011.502 3.653c0 1.37-.54 2.683-1.502 3.652l6.682-6.728-3.63-3.653z"
        fill="url(#paint1_linear)"
      />
    </g>
  ),
});

export const MastercardIcon = createIcon({
  displayName: 'MastercardIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      width="24"
      height="20"
      viewBox="0 0 21 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="6.63158" cy="7.49999" r="6.63158" fill="#EB001B" />
      <circle cx="14.3686" cy="7.49999" r="6.63158" fill="#F79E1B" />
    </svg>
  ),
});

export const PayPalIcon = createIcon({
  displayName: 'PayPalIcon',
  viewBox: '0 0 24 24',
  path: (
    <g>
      <path
        fill="currentColor"
        d="M16.179 2.532C15.142 1.357 13.265.854 10.863.854H3.895a.997.997 0 00-.986.834L.007 19.945a.595.595 0 00.591.686H4.9l1.08-6.8-.033.215a.993.993 0 01.983-.834h2.044c4.017 0 7.16-1.619 8.08-6.3.027-.14.07-.406.07-.406.262-1.732-.001-2.907-.945-3.974z"
      />
      <path
        fill="currentColor"
        d="M18.213 7.393c-.998 4.61-4.184 7.048-9.24 7.048H7.142L5.773 23.1h2.973a.87.87 0 00.862-.731l.035-.184.684-4.297.044-.237a.87.87 0 01.86-.731h.544c3.514 0 6.264-1.416 7.068-5.51.322-1.644.166-3.021-.63-4.017z"
      />
    </g>
  ),
});

export const PersonIcon = createIcon({
  displayName: 'PersonIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      d="M14.618 3.338c-.855-.924-2.05-1.432-3.368-1.432-1.325 0-2.524.505-3.375 1.423-.86.928-1.28 2.188-1.181 3.55.195 2.686 2.239 4.87 4.556 4.87s4.358-2.184 4.556-4.87c.1-1.349-.322-2.607-1.188-3.541zM18.984 21.592H3.515a1.363 1.363 0 01-1.063-.489 1.552 1.552 0 01-.316-1.279c.371-2.058 1.529-3.786 3.348-5 1.616-1.076 3.664-1.67 5.766-1.67s4.15.594 5.765 1.67c1.82 1.214 2.977 2.942 3.348 5 .085.471-.03.937-.315 1.279a1.362 1.362 0 01-1.064.49z"
    />
  ),
});

export const ProfileIcon = createIcon({
  displayName: 'ProfileIcon',
  viewBox: '0 0 24 24',
  path: (
    <g>
      <path d="M0 0h24v24H0V0z" fill="transparent" />
      <path
        fill="currentColor"
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
      />
    </g>
  ),
});

export const QuestionIcon = createIcon({
  displayName: 'QuestionIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M11 16H13V18H11V16ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z"
      fill="#FDFDFC"
    />
  ),
});

export const RocketIcon = createIcon({
  displayName: 'RocketIcon',
  viewBox: '0 0 24 24',
  path: (
    <g>
      <path
        fill="currentColor"
        d="M20.99 2.182a.209.209 0 00-.156-.16c-2.574-.63-8.521 1.613-11.743 4.833a13.93 13.93 0 00-1.566 1.85c-.994-.087-1.987-.014-2.834.355-2.39 1.052-3.085 3.796-3.279 4.976a.424.424 0 00.464.492l3.837-.423c.002.29.02.578.052.866.02.2.108.386.25.527l1.486 1.482a.86.86 0 00.528.25c.286.033.573.05.86.053l-.42 3.832a.424.424 0 00.492.464c1.178-.19 3.927-.885 4.972-3.274.37-.847.445-1.836.36-2.824a13.96 13.96 0 001.855-1.567c3.232-3.216 5.462-9.03 4.842-11.732zm-8.067 7.896a2.11 2.11 0 112.983-2.984 2.11 2.11 0 01-2.983 2.984z"
      />
      <path
        fill="currentColor"
        d="M7.4 18.054c-.24.241-.627.335-1.092.416-1.044.178-1.967-.725-1.779-1.78.072-.401.283-.962.415-1.094a.192.192 0 00-.16-.328 2.636 2.636 0 00-1.544.753c-1.033 1.034-1.13 4.87-1.13 4.87s3.838-.097 4.872-1.13c.417-.417.682-.961.752-1.546.017-.184-.207-.293-.334-.16z"
      />
    </g>
  ),
});

export const SettingsIcon = createIcon({
  displayName: 'SettingsIcon',
  viewBox: '0 0 24 24',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <g>
      <path d="M0,0h24v24H0V0z" fill="none" />
      <path
        fill="currentColor"
        d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
      />
    </g>
  ),
});

export const StoreIcon = createIcon({
  displayName: 'StoreIcon',
  viewBox: '0 0 24 24',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <g>
      <path d="M0 0H24V24H0V0Z" fill="none" />
      <path
        fill="currentColor"
        d="M20 4H4V6H20V4ZM21 14V12L20 7H4L3 12V14H4V20H14V14H18V20H20V14H21ZM12 18H6V14H12V18Z"
      />
    </g>
  ),
});

export const SlackLogo = createIcon({
  displayName: 'SlackLogo',
  viewBox: '0 0 24 24',
  path: (
    <g clipPath="url(#clip0)" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M7.832.5c-1.105 0-2 .919-1.999 2.05 0 1.13.895 2.048 2 2.05h2V2.55c.001-1.13-.894-2.048-2-2.05zm0 5.467H2.5c-1.106 0-2.001.918-2 2.05-.002 1.13.894 2.048 2 2.05h5.332c1.106-.001 2.002-.919 2-2.05.002-1.132-.894-2.05-2-2.05z"
        fill="#36C5F0"
      />
      <path
        d="M20.5 8.016c0-1.13-.895-2.048-2-2.05-1.106.002-2.002.92-2 2.05v2.05h2c1.105 0 2-.918 2-2.05zm-5.334 0V2.55c.001-1.13-.893-2.048-2-2.05-1.105 0-2 .919-2 2.05v5.466c-.001 1.131.894 2.049 2 2.05 1.106 0 2.001-.918 2-2.05z"
        fill="#2EB67D"
      />
      <path
        d="M13.166 21c1.106 0 2.001-.919 2-2.05.001-1.13-.894-2.048-2-2.05h-2v2.05c-.001 1.13.894 2.048 2 2.05zm0-5.467h5.333c1.106-.001 2.002-.92 2-2.05.002-1.131-.893-2.049-1.999-2.05h-5.333c-1.106 0-2.001.918-2 2.05-.001 1.13.893 2.049 1.999 2.05z"
        fill="#ECB22E"
      />
      <path
        d="M.5 13.483c-.001 1.13.895 2.049 2 2.05 1.106-.001 2.001-.92 2-2.05v-2.05h-2c-1.105.001-2.001.919-2 2.05zm5.333 0v5.467c-.001 1.13.894 2.048 2 2.05 1.105 0 2-.919 2-2.05v-5.465c.002-1.131-.894-2.05-2-2.05-1.106 0-2 .917-2 2.048z"
        fill="#E01E5A"
      />
    </g>
  ),
});

export const SpotifyLogo = createIcon({
  displayName: 'SpotifyLogo',
  viewBox: '0 0 24 24',
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M10.5 0C4.977 0 .5 4.477.5 10s4.477 10 10 10 10-4.477 10-10c0-5.522-4.477-10-10-10zm4.586 14.422a.623.623 0 01-.857.208c-2.348-1.435-5.304-1.76-8.785-.964a.623.623 0 11-.277-1.216c3.808-.87 7.076-.495 9.712 1.115.294.181.387.564.207.857zm1.223-2.722a.78.78 0 01-1.072.257c-2.687-1.652-6.786-2.13-9.965-1.166a.78.78 0 01-.973-.519.781.781 0 01.52-.972c3.632-1.102 8.147-.569 11.233 1.329a.78.78 0 01.258 1.072zm.106-2.835C13.19 6.95 7.875 6.775 4.797 7.708a.935.935 0 11-.543-1.79c3.533-1.072 9.404-.865 13.115 1.338a.935.935 0 01-.954 1.609z"
        fill="#2EBD59"
      />
    </g>
  ),
});

export const SupportIcon = createIcon({
  // Doesn't display the full icon without w and h being specified
  displayName: 'BuildIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      d="M20.885 5.547a.703.703 0 00-1.122-.176l-2.7 2.702a.708.708 0 01-.995 0l-1.167-1.169a.702.702 0 010-.994l2.689-2.69a.704.704 0 00-.21-1.138c-2.031-.908-4.566-.435-6.164 1.152-1.358 1.348-1.763 3.455-1.11 5.78a.698.698 0 01-.197.703L2.593 16.4a2.82 2.82 0 103.981 3.983l6.754-7.332a.699.699 0 01.693-.2 7.885 7.885 0 002.03.279c1.469 0 2.757-.475 3.686-1.39 1.72-1.695 1.983-4.57 1.148-6.192zM4.623 19.901a1.407 1.407 0 11-.305-2.797 1.407 1.407 0 01.305 2.797z"
    />
  ),
});

export const StatsIcon = createIcon({
  displayName: 'StatsIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      d="M4.57 22.297H3.164a1.055 1.055 0 01-1.055-1.054v-6.328a1.055 1.055 0 011.055-1.055H4.57a1.055 1.055 0 011.055 1.055v6.328a1.055 1.055 0 01-1.055 1.054zM14.414 22.296h-1.406a1.055 1.055 0 01-1.055-1.055V10.695a1.055 1.055 0 011.055-1.055h1.406a1.055 1.055 0 011.055 1.055V21.24a1.055 1.055 0 01-1.055 1.055zM19.336 22.297H17.93a1.055 1.055 0 01-1.055-1.055V5.773A1.055 1.055 0 0117.93 4.72h1.406a1.055 1.055 0 011.055 1.054v15.47a1.055 1.055 0 01-1.055 1.054zM9.492 22.297H8.086a1.055 1.055 0 01-1.055-1.055V2.257a1.055 1.055 0 011.055-1.054h1.406a1.055 1.055 0 011.055 1.054v18.985a1.055 1.055 0 01-1.055 1.055z"
    />
  ),
});

export const WalletIcon = createIcon({
  displayName: 'WalletIcon',
  viewBox: '0 0 24 24',
  path: (
    <g>
      <path
        fill="currentColor"
        d="M4.447 4.818h14.062c.164 0 .328.01.491.031a2.9 2.9 0 00-3.406-2.441L4.03 4.382h-.013a2.9 2.9 0 00-1.805 1.149 3.848 3.848 0 012.236-.713zM18.51 5.875H4.446a2.816 2.816 0 00-2.813 2.812v8.438a2.816 2.816 0 002.813 2.812h14.062a2.815 2.815 0 002.813-2.812V8.687a2.815 2.815 0 00-2.813-2.812zm-2.088 8.437a1.406 1.406 0 110-2.811 1.406 1.406 0 010 2.811z"
      />
      <path
        fill="currentColor"
        d="M1.656 11.651V7.28c0-.952.528-2.549 2.358-2.895 1.553-.291 3.091-.291 3.091-.291s1.011.703.176.703-.813 1.077 0 1.077 0 1.032 0 1.032L4.007 10.62l-2.35 1.032z"
      />
    </g>
  ),
});

export const VisaIcon = createIcon({
  displayName: 'VisaIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      width="26"
      height="20"
      viewBox="0 0 30 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6708 2.96349C12.6568 4.15055 13.653 4.81298 14.4034 5.20684C15.1744 5.61099 15.4333 5.87013 15.4304 6.23147C15.4245 6.78459 14.8153 7.02862 14.2452 7.03812C13.2505 7.05475 12.6723 6.74889 12.2125 6.51753L11.8542 8.32341C12.3155 8.55247 13.1696 8.75217 14.0554 8.76087C16.1345 8.76087 17.4947 7.65543 17.5021 5.94145C17.5102 3.76625 14.7087 3.64579 14.7278 2.67348C14.7344 2.37871 14.9956 2.06408 15.568 1.98406C15.8512 1.94368 16.6332 1.91274 17.5198 2.35252L17.8677 0.605286C17.391 0.418253 16.7782 0.239136 16.0153 0.239136C14.0583 0.239136 12.6819 1.35962 12.6708 2.96349ZM21.2115 0.389687C20.8319 0.389687 20.5118 0.628245 20.3691 0.99433L17.3991 8.63249H19.4767L19.8901 7.40183H22.429L22.6689 8.63249H24.5L22.9021 0.389687H21.2115ZM21.5021 2.61641L22.1016 5.7116H20.4596L21.5021 2.61641ZM10.1518 0.389687L8.51418 8.63249H10.4939L12.1308 0.389687H10.1518ZM7.22303 0.389687L5.16233 6.00003L4.32878 1.22966C4.23097 0.697187 3.84472 0.389687 3.41579 0.389687H0.0471011L0 0.629037C0.691574 0.790671 1.47729 1.0514 1.95326 1.33033C2.24457 1.50067 2.32775 1.64964 2.42336 2.05458L4.00214 8.63249H6.0945L9.3021 0.389687H7.22303Z"
        fill="#4318FF"
      />
    </svg>
  ),
});

export const MarkerDistance = createIcon({
  displayName: 'MarkerDistance',
  viewBox: '0 0 24 24',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      width="1em"
      height="1em"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M6.5 8.11c-.89 0-1.61-.72-1.61-1.61A1.61 1.61 0 0 1 6.5 4.89c.89 0 1.61.72 1.61 1.61A1.61 1.61 0 0 1 6.5 8.11M6.5 2C4 2 2 4 2 6.5c0 3.37 4.5 8.36 4.5 8.36S11 9.87 11 6.5C11 4 9 2 6.5 2m11 6.11a1.61 1.61 0 0 1-1.61-1.61a1.609 1.609 0 1 1 3.22 0a1.61 1.61 0 0 1-1.61 1.61m0-6.11C15 2 13 4 13 6.5c0 3.37 4.5 8.36 4.5 8.36S22 9.87 22 6.5C22 4 20 2 17.5 2m0 14c-1.27 0-2.4.8-2.82 2H9.32a3 3 0 0 0-3.82-1.83A3.003 3.003 0 0 0 3.66 20a3.017 3.017 0 0 0 3.84 1.83c.85-.3 1.5-.98 1.82-1.83h5.37c.55 1.56 2.27 2.38 3.81 1.83A3 3 0 0 0 20.35 18c-.43-1.2-1.57-2-2.85-2m0 4.5A1.5 1.5 0 0 1 16 19a1.5 1.5 0 0 1 1.5-1.5A1.5 1.5 0 0 1 19 19a1.5 1.5 0 0 1-1.5 1.5Z"
      />
    </svg>
  ),
});

export const BikletaIcon = createIcon({
  displayName: 'BikletaIcon',
  viewBox: '0 0 24 24',
  path: (
    <svg
      role="img"
      // width="1em"
      // height="1em"
      viewBox="0 0 84 52"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M56.4393 13.2413C55.1091 10.161 53.7788 7.18882 52.4979 4.21664C51.2662 1.35254 51.9559 0.271752 54.8627 0.217712C57.0798 0.217712 59.2969 0.217712 61.5139 0.217712C62.7949 0.217712 63.8295 0.595989 64.0266 2.16314C64.1744 3.40605 63.1398 4.27068 61.4647 4.4328C60.8242 4.48684 60.1344 4.48684 59.4939 4.48684C58.952 4.48684 58.3608 4.48684 57.4247 4.48684C58.3608 7.0267 59.1491 9.24232 60.0359 11.6201C66.5885 9.83676 72.5007 10.8635 77.6246 15.673C81.2704 19.0775 83.4382 23.4547 83.8816 28.6966C84.867 39.8828 78.0187 49.6099 68.0666 50.9609C56.3408 52.5821 48.655 42.963 47.6203 34.9111C48.8028 33.7763 50.0837 32.5874 51.4632 31.2905C53.631 42.4767 60.3315 47.9347 68.9041 45.7731C76.2943 43.9357 80.9748 35.4515 79.0534 27.2915C77.1319 19.0775 69.7417 14.214 62.2037 16.4296C62.4008 17.0781 62.4993 17.7806 62.7456 18.375C64.1251 21.8335 65.5539 25.2921 66.9334 28.7506C67.229 29.5072 67.5246 30.2637 67.6232 31.0203C67.771 32.2091 67.2783 33.344 66.1944 33.4521C65.4554 33.5601 64.4207 33.1819 63.8788 32.5874C63.2876 31.9389 63.0412 30.8582 62.6964 29.9395C61.2676 26.1567 59.8388 22.3199 58.213 18.0508C56.6857 19.3477 55.3062 20.4285 54.1237 21.6714C46.9306 28.9668 39.7867 36.3702 32.5443 43.7196C29.6375 46.6917 26.5336 49.3397 22.6414 50.5286C12.4429 53.5548 1.55468 45.5029 0.175176 33.9384C-1.59847 19.1316 10.3737 7.62113 23.5282 11.566C23.9717 11.7281 24.4643 11.8362 25.4004 12.1064C24.8585 10.3231 24.3658 8.86404 23.8731 7.24286C22.8878 7.24286 22.0009 7.2969 21.1141 7.24286C19.439 7.13478 18.4044 6.16207 18.4536 4.75704C18.5029 3.40605 19.3897 2.48737 21.0156 2.48737C24.3658 2.3793 27.716 2.3793 31.0663 2.43334C32.6428 2.48737 33.5297 3.40605 33.5297 4.81108C33.5297 6.16207 32.5936 7.13478 31.1155 7.24286C30.0809 7.2969 28.997 7.24286 27.6175 7.24286C28.6521 10.2691 29.5389 12.917 30.5243 15.7811C35.8453 15.7811 41.0677 15.7811 46.2901 15.7811C46.3886 15.9432 46.4872 16.1594 46.5857 16.3215C45.4525 17.6185 44.3194 18.8614 43.1862 20.2124C40.2301 20.2124 37.3726 20.2124 34.318 20.2124C35.057 22.5361 35.7467 24.6976 36.4365 26.8592C35.0077 28.1562 33.8253 29.345 32.3965 30.642C32.1009 29.1289 31.9531 27.94 31.6082 26.7511C29.6375 19.1856 22.6414 14.5382 15.4975 16.0513C8.50148 17.5644 3.62394 25.13 4.6093 33.0738C5.5454 40.7474 11.8517 46.4756 18.9463 46.1514C22.0502 45.9892 24.7107 44.6382 26.9277 42.4226C35.3033 34.2086 43.6296 25.8865 51.9559 17.6725C53.434 16.2134 54.912 14.8084 56.4393 13.2413Z"
      />
    </svg>
  ),
});

export const GoogleIcon = createIcon({
  displayName: 'GoogleIcon',
  path: (
    <g transform="matrix(1, 0, 0, 1, 27.009001, -39.238998)">
      <path
        fill="#4285F4"
        d="M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.229 -9.424 56.479 -10.684 57.329 L -10.684 60.329 L -6.824 60.329 C -4.564 58.239 -3.264 55.159 -3.264 51.509 Z"
      />
      <path
        fill="#34A853"
        d="M -14.754 63.239 C -11.514 63.239 -8.804 62.159 -6.824 60.329 L -10.684 57.329 C -11.764 58.049 -13.134 58.489 -14.754 58.489 C -17.884 58.489 -20.534 56.379 -21.484 53.529 L -25.464 53.529 L -25.464 56.619 C -23.494 60.539 -19.444 63.239 -14.754 63.239 Z"
      />
      <path
        fill="#FBBC05"
        d="M -21.484 53.529 C -21.734 52.809 -21.864 52.039 -21.864 51.239 C -21.864 50.439 -21.724 49.669 -21.484 48.949 L -21.484 45.859 L -25.464 45.859 C -26.284 47.479 -26.754 49.299 -26.754 51.239 C -26.754 53.179 -26.284 54.999 -25.464 56.619 L -21.484 53.529 Z"
      />
      <path
        fill="#EA4335"
        d="M -14.754 43.989 C -12.984 43.989 -11.404 44.599 -10.154 45.789 L -6.734 42.369 C -8.804 40.429 -11.514 39.239 -14.754 39.239 C -19.444 39.239 -23.494 41.939 -25.464 45.859 L -21.484 48.949 C -20.534 46.099 -17.884 43.989 -14.754 43.989 Z"
      />
    </g>
  ),
});

export const GoogleIconLight = createIcon({
  displayName: 'GoogleIconLight',
  path: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6701 6.909C12.4921 6.90792 10.3141 6.90846 8.13616 6.90871C8.13644 7.81207 8.13509 8.71543 8.1367 9.6185C9.39802 9.61822 10.6593 9.61797 11.9204 9.6185C11.7743 10.4842 11.2598 11.2758 10.5303 11.7631C10.0717 12.0715 9.54475 12.2716 9.00153 12.3668C8.45481 12.4601 7.8899 12.472 7.34453 12.3616C6.78994 12.251 6.26056 12.0199 5.79873 11.6942C5.06028 11.1754 4.49671 10.4163 4.20735 9.56206C3.91147 8.69316 3.9093 7.72633 4.20871 6.85825C4.41645 6.24643 4.76222 5.68126 5.21646 5.22132C5.77675 4.64774 6.50518 4.2377 7.29001 4.06955C7.96203 3.9261 8.67066 3.95348 9.3286 4.15253C9.88781 4.32231 10.4033 4.62874 10.8256 5.03201C11.2525 4.60758 11.6771 4.18072 12.1032 3.7555C12.3267 3.52662 12.5615 3.30776 12.7779 3.07264C12.1309 2.47383 11.3723 1.99247 10.5436 1.68818C9.05143 1.13904 7.36866 1.12738 5.86652 1.64729C4.17371 2.22683 2.7323 3.49275 1.93311 5.09283C1.65487 5.64417 1.45173 6.23266 1.3297 6.83796C1.0227 8.34606 1.23668 9.95401 1.93229 11.3276C2.38438 12.2242 3.03253 13.0212 3.81873 13.646C4.56046 14.2375 5.42502 14.6744 6.34167 14.9182C7.49832 15.2285 8.72953 15.2214 9.8938 14.9565C10.946 14.7143 11.9416 14.2115 12.7365 13.4776C13.5766 12.7055 14.1759 11.6883 14.4932 10.5951C14.8393 9.40266 14.887 8.12965 14.6701 6.909Z"
        fill="#FDFDFC"
      />
    </svg>
  ),
});

export const LinkIcon = createIcon({
  displayName: 'LinkIcon',
  path: (
    <svg width="24px" height="24px" viewBox="0 -0.5 25 25" fill="none">
      <path
        d="M11.1828 7.68276C10.8899 7.97566 10.8899 8.45053 11.1828 8.74342C11.4756 9.03632 11.9505 9.03632 12.2434 8.74342L11.1828 7.68276ZM13.9851 5.94109L14.5154 6.47142V6.47142L13.9851 5.94109ZM18.5291 5.94109L17.9988 6.47142L18.5291 5.94109ZM18.5291 10.4851L17.9988 9.95476L18.5291 10.4851ZM15.7268 12.2268C15.4339 12.5197 15.4339 12.9945 15.7268 13.2874C16.0196 13.5803 16.4945 13.5803 16.7874 13.2874L15.7268 12.2268ZM13.7583 16.3185C14.0513 16.0257 14.0514 15.5508 13.7585 15.2579C13.4657 14.9649 12.9908 14.9648 12.6979 15.2576L13.7583 16.3185ZM10.9561 18.0591L11.4797 18.5961L11.4863 18.5895L10.9561 18.0591ZM6.44132 18.0309L5.91104 18.5612H5.91104L6.44132 18.0309ZM6.41208 13.5161L5.88171 12.9857L5.87499 12.9926L6.41208 13.5161ZM9.21441 11.7744C9.50731 11.4815 9.50731 11.0067 9.21441 10.7138C8.92152 10.4209 8.44665 10.4209 8.15375 10.7138L9.21441 11.7744ZM15.2744 10.2574C15.5673 9.96453 15.5673 9.48966 15.2744 9.19676C14.9815 8.90387 14.5066 8.90387 14.2138 9.19676L15.2744 10.2574ZM9.66975 13.7408C9.37686 14.0337 9.37686 14.5085 9.66975 14.8014C9.96265 15.0943 10.4375 15.0943 10.7304 14.8014L9.66975 13.7408ZM12.2434 8.74342L14.5154 6.47142L13.4548 5.41076L11.1828 7.68276L12.2434 8.74342ZM14.5154 6.47142C15.4773 5.50953 17.0369 5.50953 17.9988 6.47142L19.0594 5.41076C17.5117 3.86308 15.0024 3.86308 13.4548 5.41076L14.5154 6.47142ZM17.9988 6.47142C18.9607 7.43332 18.9607 8.99287 17.9988 9.95476L19.0594 11.0154C20.6071 9.46774 20.6071 6.95845 19.0594 5.41076L17.9988 6.47142ZM17.9988 9.95476L15.7268 12.2268L16.7874 13.2874L19.0594 11.0154L17.9988 9.95476ZM12.6979 15.2576L10.4259 17.5286L11.4863 18.5895L13.7583 16.3185L12.6979 15.2576ZM10.4325 17.5221C9.46732 18.4632 7.92491 18.4536 6.97159 17.5005L5.91104 18.5612C7.44495 20.0948 9.92671 20.1103 11.4797 18.5961L10.4325 17.5221ZM6.97159 17.5005C6.01827 16.5474 6.00828 15.0049 6.94918 14.0396L5.87499 12.9926C4.36107 14.5459 4.37714 17.0277 5.91104 18.5612L6.97159 17.5005ZM6.94241 14.0464L9.21441 11.7744L8.15375 10.7138L5.88175 12.9858L6.94241 14.0464ZM14.2138 9.19676L9.66975 13.7408L10.7304 14.8014L15.2744 10.2574L14.2138 9.19676Z"
        fill="#FDFDFC"
      />
    </svg>
  ),
});

export const LocationIcon = createIcon({
  displayName: 'LocationIcon',
  path: (
    <svg
      fill="#FDFDFC"
      height="24px"
      width="24px"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      enable-background="new 0 0 24 24">
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g id="Location-Filled">
          <path d="M12,1C7.58,1,4,4.58,4,9c0,7.08,8,14,8,14s8-6.92,8-14C20,4.58,16.42,1,12,1z M12,12c-1.66,0-3-1.34-3-3s1.34-3,3-3 s3,1.34,3,3S13.66,12,12,12z"></path>
        </g>
      </g>
    </svg>
  ),
});

export const FlagLocationIcon = createIcon({
  displayName: 'FlagLocationIcon',
  viewBox: '0 0 18 18',
  path: (
    <path
      d="M15.375 2.25L15.255 2.2725L11.25 3.825L6.75 2.25L2.52 3.675C2.3625 3.7275 2.25 3.8625 2.25 4.035V15.375C2.25 15.585 2.415 15.75 2.625 15.75L2.745 15.7275L6.75 14.175L11.25 15.75L15.48 14.325C15.6375 14.2725 15.75 14.1375 15.75 13.965V2.625C15.75 2.415 15.585 2.25 15.375 2.25ZM11.25 14.25L6.75 12.6675V3.75L11.25 5.3325V14.25Z"
    />
  ),
});

export const RunnerIcon = createIcon({
  displayName: 'RunnerIcon',
  viewBox: '0 0 18 18',
  path: (
    <path
      d="M10.1174 4.10986C10.9424 4.10986 11.6174 3.43486 11.6174 2.60986C11.6174 1.78486 10.9424 1.10986 10.1174 1.10986C9.29241 1.10986 8.61741 1.78486 8.61741 2.60986C8.61741 3.43486 9.29241 4.10986 10.1174 4.10986ZM7.73991 13.1099L8.16741 11.2349L9.74241 12.7349V16.4849C9.74241 16.8974 10.0799 17.2349 10.4924 17.2349C10.9049 17.2349 11.2424 16.8974 11.2424 16.4849V12.2549C11.2424 11.8424 11.0774 11.4524 10.7774 11.1674L9.66741 10.1099L10.1174 7.85986C10.9199 8.78986 12.0824 9.45736 13.3874 9.66736C13.8374 9.73486 14.2424 9.37486 14.2424 8.91736C14.2424 8.54986 13.9724 8.24236 13.6049 8.18236C12.4649 7.99486 11.5199 7.31986 11.0174 6.43486L10.2674 5.23486C9.96741 4.78486 9.51741 4.48486 8.99241 4.48486C8.76741 4.48486 8.61741 4.55986 8.39241 4.55986L5.40741 5.81986C4.85241 6.05986 4.49241 6.59986 4.49241 7.20736V8.98486C4.49241 9.39736 4.82991 9.73486 5.24241 9.73486C5.65491 9.73486 5.99241 9.39736 5.99241 8.98486V7.18486L7.34241 6.65986L6.14241 12.7349L3.20241 12.1349C2.79741 12.0524 2.39991 12.3149 2.31741 12.7199V12.7499C2.23491 13.1549 2.49741 13.5524 2.90241 13.6349L5.98491 14.2499C6.77991 14.4074 7.55991 13.9049 7.73991 13.1099Z"
    />
  ),
});

export const GitHubIcon = createIcon({
  displayName: 'GitHubIcon',
  path: (
    <path
      fill="currentColor"
      d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"
    />
  ),
});

export const TwitterIcon = createIcon({
  displayName: 'TwitterIcon',
  path: (
    <path
      fill="#03A9F4"
      d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"
    />
  ),
});

export const MenuIcon = createIcon({
  displayName: 'MenuIcon',
  path: (
    <svg
      width="50"
      height="50"
      viewBox="0 2 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 2V0H18V2H0ZM0 7H18V5H0V7ZM0 12H18V10H0V12Z"
        fill="#FDFDFC"
      />
    </svg>
  ),
});

export const MenuIconDark = createIcon({
  displayName: 'MenuIcon',
  path: (
    <svg
      width="50"
      height="50"
      viewBox="0 2 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 2V0H18V2H0ZM0 7H18V5H0V7ZM0 12H18V10H0V12Z"
        fill="black"
      />
    </svg>
  ),
});

export const DarkArrowIcon = createIcon({
  displayName: 'DarkArrowIcon',
  path: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 0V12.175L1.4 6.575L0 8L8 16L16 8L14.6 6.575L9 12.175V0H7Z"
        fill="#0D0C0C"
      />
    </svg>
  ),
});

export const ToolIcon = createIcon({
  displayName: 'ToolIcon',
  viewBox: '0 0 18 18',
  path: (
    <path
      d="M9.06756 2.18247C7.56006 0.674966 5.30256 0.367466 3.48756 1.25247L6.21006 3.97497C6.50256 4.26747 6.50256 4.73997 6.21006 5.03247L5.01756 6.22497C4.72506 6.52497 4.25256 6.52497 3.96006 6.22497L1.23756 3.50247C0.360064 5.32497 0.667564 7.56747 2.17506 9.07497C3.57006 10.47 5.61006 10.8375 7.34256 10.185L13.3126 16.155C14.0851 16.9275 15.3301 16.9275 16.0951 16.155C16.8676 15.3825 16.8676 14.1375 16.0951 13.3725L10.1551 7.42497C10.8451 5.66997 10.4851 3.59997 9.06756 2.18247Z"
    />
  ),
});

export const YellowArrowIcon = createIcon({
  displayName: 'YellowArrowIcon',
  path: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 0V12.175L1.4 6.575L0 8L8 16L16 8L14.6 6.575L9 12.175V0H7Z"
        fill="#FFC700"
      />
    </svg>
  ),
});

export const UploadIcon = createIcon({
  displayName: 'UploadIcon',
  path: (
    <svg width="16" height="22" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 8.25V10.5H2V8.25H0.5V10.5C0.5 11.325 1.175 12 2 12H11C11.825 12 12.5 11.325 12.5 10.5V8.25H11ZM2.75 3.75L3.8075 4.8075L5.75 2.8725V9H7.25V2.8725L9.1925 4.8075L10.25 3.75L6.5 0L2.75 3.75Z" fill="#FDFDFC" />
    </svg>

  ),
})

export const CarretArrowDownIcon = createIcon({
  displayName: 'CarretArrowDownIco',
  path: (
    <svg width="20" height="8" viewBox="0 0 6 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0L5 5L10 0H0Z" fill="#FDFDFC" />
    </svg>
  ),
})

export const BikletaPointIcon = createIcon({
  displayName: 'BikletaPointIcon',
  path: (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 19.35C14.5333 17.4833 16.0417 15.7875 17.025 14.2625C18.0083 12.7375 18.5 11.3833 18.5 10.2C18.5 8.38333 17.9208 6.89583 16.7625 5.7375C15.6042 4.57917 14.1833 4 12.5 4C10.8167 4 9.39583 4.57917 8.2375 5.7375C7.07917 6.89583 6.5 8.38333 6.5 10.2C6.5 11.3833 6.99167 12.7375 7.975 14.2625C8.95833 15.7875 10.4667 17.4833 12.5 19.35ZM12.5 22C9.81667 19.7167 7.8125 17.5958 6.4875 15.6375C5.1625 13.6792 4.5 11.8667 4.5 10.2C4.5 7.7 5.30417 5.70833 6.9125 4.225C8.52083 2.74167 10.3833 2 12.5 2C14.6167 2 16.4792 2.74167 18.0875 4.225C19.6958 5.70833 20.5 7.7 20.5 10.2C20.5 11.8667 19.8375 13.6792 18.5125 15.6375C17.1875 17.5958 15.1833 19.7167 12.5 22Z" fill="#0D0C0C"/>
    <path d="M14.9092 6.375C14.9971 6.37501 15.0977 6.38616 15.1826 6.43848C15.252 6.48129 15.3003 6.54519 15.3271 6.62598L15.3477 6.71289V6.71387C15.3625 6.83305 15.314 6.93591 15.2275 7.00684C15.1457 7.07398 15.0341 7.11015 14.9141 7.12109H14.9131L14.6562 7.12793H14.5811C14.6574 7.32486 14.7275 7.50697 14.8018 7.69629C15.6125 7.51523 16.3581 7.65397 17.0059 8.22656C17.4848 8.64784 17.7715 9.192 17.8301 9.8418C17.9589 11.2191 17.0622 12.4311 15.7441 12.5996C14.1973 12.8008 13.1847 11.605 13.0479 10.6025L13.0391 10.5371L13.0879 10.4932C13.2363 10.359 13.3977 10.2174 13.5693 10.0654L13.7314 9.92188L13.7744 10.1338C13.9059 10.7729 14.1724 11.2329 14.5195 11.5029C14.8635 11.7704 15.3015 11.8627 15.8047 11.7432L15.9609 11.6973C16.722 11.4277 17.1908 10.5603 16.9805 9.71875C16.7665 8.8572 15.9776 8.3396 15.1504 8.50195L15.1777 8.58789L15.1787 8.58984H15.1777C15.2637 8.79285 15.3517 8.99572 15.4395 9.19922L15.7021 9.81152V9.8125C15.7288 9.87674 15.7599 9.95147 15.7803 10.0303L15.7969 10.1104V10.1113C15.8088 10.2023 15.7961 10.2991 15.75 10.3799C15.7023 10.4632 15.6202 10.5243 15.5107 10.5361L15.5117 10.5371H15.5098C15.5085 10.5372 15.5071 10.538 15.5059 10.5381V10.5371C15.4365 10.5455 15.3626 10.534 15.2988 10.5117C15.2333 10.4888 15.1659 10.4508 15.1152 10.3984C15.0614 10.3428 15.028 10.2741 15.0039 10.2148C14.9916 10.1846 14.9797 10.154 14.9697 10.126C14.9594 10.097 14.9502 10.0704 14.9404 10.0459V10.0449C14.7801 9.64513 14.6201 9.24189 14.4424 8.80078C14.3029 8.91064 14.182 9.00758 14.0732 9.11523L14.0713 9.11719C13.622 9.5463 13.1744 9.97872 12.7256 10.4121C12.2769 10.8454 11.8259 11.2791 11.373 11.7119C11.0059 12.0654 10.6 12.3962 10.083 12.5449H10.082C8.72815 12.9231 7.2966 11.9182 7.11523 10.4863C6.88335 8.66122 8.45575 7.2252 10.1934 7.71582L10.2002 7.71777H10.2012C10.1931 7.69391 10.1857 7.67002 10.1777 7.64648C10.1558 7.58186 10.135 7.51759 10.1133 7.45215C10.0261 7.45364 9.93503 7.45705 9.84961 7.45215C9.72517 7.44451 9.61111 7.40587 9.52734 7.33203C9.44118 7.25596 9.39605 7.14954 9.40039 7.03027V7.0293C9.40469 6.92084 9.44571 6.81984 9.5293 6.74707C9.61091 6.67602 9.72003 6.64321 9.8418 6.64258L10.4736 6.63184C10.6838 6.63104 10.8937 6.63256 11.1035 6.63574H11.1064C11.2262 6.63967 11.335 6.6758 11.415 6.75C11.4965 6.82566 11.5352 6.92913 11.5352 7.04102C11.5351 7.15282 11.4931 7.25429 11.415 7.3291C11.3379 7.4029 11.233 7.4441 11.1172 7.45215H10.8486C10.9432 7.71384 11.0298 7.95457 11.1221 8.20801H13.0732L13.1104 8.26465C13.1192 8.2784 13.1281 8.29351 13.1338 8.30371C13.1403 8.3155 13.1441 8.32287 13.1475 8.32812L13.2002 8.41016L13.1338 8.48145C12.9897 8.63671 12.8515 8.77965 12.7109 8.9375L12.6738 8.97949H11.6826C11.7543 9.19162 11.823 9.39413 11.8916 9.59668L11.9189 9.67773L11.8545 9.73242C11.7665 9.80761 11.6862 9.8799 11.6045 9.95312C11.523 10.0262 11.4402 10.1003 11.3496 10.1777L11.1885 10.3154L11.1455 10.1084C11.1061 9.91861 11.0917 9.79384 11.0508 9.66113L11.0488 9.6582V9.65723C10.8192 8.82835 10.0069 8.32132 9.17969 8.48633L9.18066 8.4873C8.42534 8.64116 7.87506 9.37678 7.9043 10.1895L7.91797 10.3525V10.3535C8.02713 11.1943 8.76059 11.8179 9.58008 11.7832C9.93498 11.7657 10.2408 11.622 10.499 11.3789L10.5 11.3779C11.5472 10.4107 12.5868 9.43205 13.6289 8.46387L14.1221 8.00293C14.0519 7.85062 13.9819 7.70026 13.9121 7.55078C13.8297 7.37425 13.7483 7.19795 13.668 7.02246C13.6272 6.93308 13.5981 6.84926 13.5879 6.77246C13.5775 6.69447 13.5852 6.61394 13.6299 6.54395C13.6745 6.4741 13.7442 6.43381 13.8184 6.41016C13.8916 6.38681 13.9788 6.37669 14.0752 6.375H14.9092Z" fill="#0D0C0C" stroke="#0D0C0C" stroke-width="0.25"/>
  </svg>
  )
})

export const UserIcon = createIcon({
  displayName: 'UserIcon',
  path: (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5582_42054)">
        <path d="M12.5 5.9C13.66 5.9 14.6 6.84 14.6 8C14.6 9.16 13.66 10.1 12.5 10.1C11.34 10.1 10.4 9.16 10.4 8C10.4 6.84 11.34 5.9 12.5 5.9ZM12.5 14.9C15.47 14.9 18.6 16.36 18.6 17V18.1H6.4V17C6.4 16.36 9.53 14.9 12.5 14.9ZM12.5 4C10.29 4 8.5 5.79 8.5 8C8.5 10.21 10.29 12 12.5 12C14.71 12 16.5 10.21 16.5 8C16.5 5.79 14.71 4 12.5 4ZM12.5 13C9.83 13 4.5 14.34 4.5 17V20H20.5V17C20.5 14.34 15.17 13 12.5 13Z" fill="#0D0C0C"/>
      </g>
      <defs>
        <clipPath id="clip0_5582_42054">
          <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
        </clipPath>
      </defs>
    </svg>
  )
})

export const GiftIcon = createIcon({
  displayName: 'GiftIcon',
  path: (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.6818 12V18.4C20.6818 18.8243 20.5094 19.2313 20.2025 19.5314C19.8957 19.8314 19.4794 20 19.0455 20H5.95455C5.52055 20 5.10434 19.8314 4.79746 19.5314C4.49058 19.2313 4.31818 18.8243 4.31818 18.4V12C4.10119 12 3.89308 11.9157 3.73964 11.7657C3.5862 11.6157 3.5 11.4122 3.5 11.2V8.8C3.5 8.37565 3.6724 7.96869 3.97928 7.66863C4.28616 7.36857 4.70237 7.2 5.13636 7.2H7.73C7.64 6.952 7.59091 6.68 7.59091 6.4C7.59091 5.76348 7.84951 5.15303 8.30983 4.70294C8.77015 4.25286 9.39447 4 10.0455 4C10.8636 4 11.5836 4.4 12.0336 4.992V4.984L12.5 5.6L12.9664 4.984V4.992C13.4164 4.4 14.1364 4 14.9545 4C15.6055 4 16.2299 4.25286 16.6902 4.70294C17.1505 5.15303 17.4091 5.76348 17.4091 6.4C17.4091 6.68 17.36 6.952 17.27 7.2H19.8636C20.2976 7.2 20.7138 7.36857 21.0207 7.66863C21.3276 7.96869 21.5 8.37565 21.5 8.8V11.2C21.5 11.4122 21.4138 11.6157 21.2604 11.7657C21.1069 11.9157 20.8988 12 20.6818 12ZM5.95455 18.4H11.6818V12H5.95455V18.4ZM19.0455 18.4V12H13.3182V18.4H19.0455ZM10.0455 5.6C9.82846 5.6 9.62035 5.68429 9.46691 5.83431C9.31347 5.98434 9.22727 6.18783 9.22727 6.4C9.22727 6.61217 9.31347 6.81566 9.46691 6.96569C9.62035 7.11571 9.82846 7.2 10.0455 7.2C10.2624 7.2 10.4706 7.11571 10.624 6.96569C10.7774 6.81566 10.8636 6.61217 10.8636 6.4C10.8636 6.18783 10.7774 5.98434 10.624 5.83431C10.4706 5.68429 10.2624 5.6 10.0455 5.6ZM14.9545 5.6C14.7375 5.6 14.5294 5.68429 14.376 5.83431C14.2226 5.98434 14.1364 6.18783 14.1364 6.4C14.1364 6.61217 14.2226 6.81566 14.376 6.96569C14.5294 7.11571 14.7375 7.2 14.9545 7.2C15.1715 7.2 15.3796 7.11571 15.5331 6.96569C15.6865 6.81566 15.7727 6.61217 15.7727 6.4C15.7727 6.18783 15.6865 5.98434 15.5331 5.83431C15.3796 5.68429 15.1715 5.6 14.9545 5.6ZM5.13636 8.8V10.4H11.6818V8.8H5.13636ZM13.3182 8.8V10.4H19.8636V8.8H13.3182Z" fill="#0D0C0C"/>
    </svg>

  )
})
